"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUncommonProps = exports.getCommonProps = void 0;
const getCommonProps = (props) => {
    return { 'data-testid': props['data-testid'] };
};
exports.getCommonProps = getCommonProps;
const getUncommonProps = (props) => {
    const commonPropKeys = Object.keys((0, exports.getCommonProps)(props));
    return Object.keys(props).filter((propKey) => !commonPropKeys.includes(propKey)).reduce((accumulator, propKey) => (Object.assign(Object.assign({}, accumulator), { [propKey]: props[propKey] })), {});
};
exports.getUncommonProps = getUncommonProps;
